module.exports = __webpack_public_path__ + "img/image_part_007.74cd0eeb.jpg";